import script from "./BlackWarningTip.vue?vue&type=script&lang=ts&setup=true"
export * from "./BlackWarningTip.vue?vue&type=script&lang=ts&setup=true"

import "./BlackWarningTip.vue?vue&type=style&index=0&id=b6b0d2e4&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6b0d2e4"]])

export default __exports__